import React, { useState } from "react";
import "./chart.css";
import { Box, Typography } from "@mui/material";
import OpenWithIcon from '@mui/icons-material/OpenWith';

const MAX_BAR_HEIGHT = 40;

export default function AntenatalChart({ data, name, handleOpen, settingType }) {
    const [hoverData, setHoverData] = useState(null);

    return (
        <Box sx={{ width: '100%',  height:'90%',  }}>
            {<Box sx={{ display: 'flex', justifyContent: 'space-between', alignContent: 'space-between' }}>
                <Typography
                    variant="p"
                    align="left"
                    sx={{ marginLeft: 2, fontSize: "14px", fontWeight: "bold" }}
                >
                    {name}
                </Typography>

                {handleOpen && <OpenWithIcon onClick={() => {
                    handleOpen()
                    settingType(name)
                }} sx={{ alignSelf: 'flex-end', right: 20, cursor: 'pointer',fontSize:'medium' }} />}
            </Box>}
            <div className="chart-container" style={{ justifyContent:'center',  marginTop:'5px',  overflowX: "auto",
             justifyContent: "center",}}>

                {data?.map((item, index) => {
                    const total = item.antenatalTestCount;
                    const missed = item.missedAntenatalTests.length;

                    const lightHeight = (total / total) * (handleOpen ? MAX_BAR_HEIGHT : 190);
                    const redHeight = (missed / total) * (handleOpen ?  MAX_BAR_HEIGHT : 190);

                    return (
                        <div key={index} className="bar-wrapper" onMouseEnter={() => setHoverData({ x: index, item })}
                            onMouseLeave={() => setHoverData(null)}>

                            <div className="bar" style={{ height: handleOpen ? '39px': '190px', width: handleOpen ? '11px' : '30px'}}>
                                {total === 0 ? (
                                    <div className="bar-grey" style={{ height: handleOpen ? MAX_BAR_HEIGHT: '190px'}}></div>
                                ) : (
                                    <>
                                        <div className="bar-light" style={{ height: lightHeight }}></div>
                                        {missed > 0 && (
                                            <div className="bar-red" style={{ height: redHeight }}>
                                                    <span className="bar-label" style={{ fontSize: handleOpen ? '6px' : '15px', marginTop: handleOpen ? '4px' : '10px' }}>{missed}</span>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>


                            <div className="week-text" style={{fontSize: handleOpen ? '9px': '12px', fontWeight:'bold'}}>{item.week}</div>
                            {/* Tooltip */}
                            {hoverData?.x === index && (
                                <div className="tooltip">
                                    <div className="tooltip-title">
                                        Pending: {missed}/{total}
                                    </div>
                                    {item.missedAntenatalTests.map((t, i) => (
                                        <div key={i} className="tooltip-item">
                                            • {t}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </Box>
    );
}
